export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50 rounded-t-3xl">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="lg:col-span-1">
            <h3 className="heading-font text-2xl font-bold text-white mb-4">
              MCT Residential Services
            </h3>
            <p className="text-foreground-100 text-sm leading-relaxed">
              Every young person deserves a turning point. We help youth build the skills, confidence, and relationships they need to succeed.
            </p>
          </div>

          <div>
            <h4 className="label-font text-sm font-semibold text-white mb-4 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { label: 'About MCT', href: '/about' },
                { label: 'Our Services', href: '/services' },
                { label: 'Outcomes', href: '/outcomes' },
                { label: 'For Agencies', href: '/for-agencies' },
                { label: 'Careers', href: '/careers' },
                { label: 'Contact', href: '/contact' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-foreground-200 hover:text-white text-sm transition-colors duration-200"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="label-font text-sm font-semibold text-white mb-4 uppercase tracking-wider">Connect</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:12892046406" className="text-foreground-200 hover:text-white text-sm transition-colors duration-200 flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-line"></i>
                  </span>
                  <span>1 289 204 6406</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@mctresidential.com" className="text-foreground-200 hover:text-white text-sm transition-colors duration-200 flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line"></i>
                  </span>
                  <span>info@mctresidential.com</span>
                </a>
              </li>
              <li>
                <span className="text-foreground-200 text-sm flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-map-pin-line"></i>
                  </span>
                  <span>Ontario, Canada</span>
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="label-font text-sm font-semibold text-white mb-4 uppercase tracking-wider">Stay Informed</h4>
            <p className="text-foreground-200 text-sm mb-4 leading-relaxed">
              Subscribe for updates on our programs and youth success stories.
            </p>
            <form
              action="https://readdy.ai/api/form/d9cij02lh2lp4rjvssp0"
              method="POST"
              data-readdy-form=""
              className="flex gap-2"
            >
              <input
                type="email"
                name="email"
                placeholder="Your email"
                className="flex-1 bg-foreground-800 text-white text-sm px-4 py-2.5 rounded-full border border-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="sr-only"
              />
              <button
                type="submit"
                className="w-10 h-10 flex items-center justify-center bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors cursor-pointer flex-shrink-0"
                aria-label="Subscribe"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} MCT Residential Services. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-400 hover:text-white text-xs transition-colors">Privacy Policy</a>
            <a href="#" className="text-foreground-400 hover:text-white text-xs transition-colors">Terms of Service</a>
            <a href="#" className="text-foreground-400 hover:text-white text-xs transition-colors">Accessibility</a>
          </div>
        </div>

        <div className="mt-8 overflow-hidden select-none pointer-events-none">
          <span className="heading-font text-[8rem] md:text-[12rem] font-bold text-foreground-800/20 leading-none block text-center">
            MCT
          </span>
        </div>
      </div>
    </footer>
  );
}